export default __webpack_public_path__ + "static/media/mastercard.0dded3e4.png";